import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../../../../app/store";
import axiosInstance from "../../../../../../configs/axios/axios ";
import { SHARE_FILE } from "../../../../../../configs/axios/constantsAPI";
import { getShareManagementListAction } from "../../../../share-management/shareManagementSlice";
import { setLinkFileModalAction } from "../../../../../global/link-file-modal/linkFileModalSlice";
import { getCookie } from "../../../../../../configs/cookie-helper/cookieHelper";

export const shareFileAction = createAsyncThunk(
  "drawerShare/shareFile",
  async (sendData: any, { dispatch, rejectWithValue, getState }: any) => {
    let token = getCookie("token") as string;
    try {
      const { data } = await axiosInstance.post(
        SHARE_FILE,
        {
          file_id: getState().directoryItemsState.itemInfo.id,
          name: sendData.name,
          description: sendData.description,
          direct_download: sendData.directDownloadFile,
          password: sendData.password,
          number_download: sendData.numberDownload,
          alternative_id: sendData.alternativeFile.id,
        },
        {
          headers: {
            token: token ? token : getState().authenticationState.token,
          },
        }
      );

      dispatch(
        getShareManagementListAction({
          file_id: getState().directoryItemsState.itemInfo.id,
        })
      );

      dispatch(setLinkFileModalAction(data?.content?.link));

      return data;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export interface DrawerShareState {
  shareFile: {
    actionStatus: string;
    alert: {
      error: boolean;
      message: string;
    };
    link: string;
  };
}

const initialState: DrawerShareState = {
  shareFile: {
    actionStatus: "",
    alert: {
      error: false,
      message: "",
    },
    link: "",
  },
};

export const drawerShareSlice = createSlice({
  name: "drawerShare",
  initialState,
  reducers: {
    resetShareFileStatusAction: (state) => {
      state.shareFile = {
        ...state.shareFile,
        actionStatus: "",
        alert: {
          error: false,
          message: "",
        },
      };
    },
    resetShareFileAction: (state) => {
      state.shareFile = initialState.shareFile;
    },
  },
  extraReducers: ({ addCase }) => {
    addCase(shareFileAction.pending, (state) => {
      state.shareFile.actionStatus = "loading";
      state.shareFile.alert = {
        error: false,
        message: "",
      };
    });
    addCase(shareFileAction.fulfilled, (state, { payload }) => {
      state.shareFile.actionStatus = "success";
      state.shareFile.alert = {
        error: payload.content.error,
        message: payload.content.error
          ? "Sorry, we encountered an error!"
          : "Great, we didn't encounter any errors!",
      };
      state.shareFile.link = payload.content?.link;
    });
    addCase(shareFileAction.rejected, (state, { payload }: any) => {
      state.shareFile.actionStatus = "rejected";
      state.shareFile.alert = {
        error: payload.content.error,
        message: payload.content.error
          ? payload.content.message
          : "Great, we didn't encounter any errors!",
      };
    });
  },
});

export const { resetShareFileStatusAction, resetShareFileAction } =
  drawerShareSlice.actions;

export const drawerShare = (state: RootState) => state.drawerShareState;

export default drawerShareSlice.reducer;
